import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { addBlog } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IPayloadBlog } from "./interface";
import { IReduxState } from '../../store';
import AddIcon from '@mui/icons-material/Add';
import CategorieDialog from './Categorie';

interface IAddProps {
  blogState: IPayloadBlog;
  setBlogState: (x: IPayloadBlog) => void;
  setSelectedPhoto: (x: any) => void;
  image: string;
  setImage: (x: string) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    blogState,
    setBlogState,
    setSelectedPhoto,
    image,
    setImage
  } = props
  //redux
  const { categories } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks
  const selectPhoto: any = useRef(null);
  const selectGaleriePhoto: any = useRef(null);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setBlogState({ ...blogState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >

        <Grid item md={3} xs={12} sm={3}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={10} xs={12} sm={10}>
              <TextField
                fullWidth
                select
                size="small"
                name="idCategorie"
                label="Catégorie"
                value={blogState.idCategorie}
                onChange={handleInputChange}
              >
                {categories.map((option) => (
                  <MenuItem key={option.idCategorie} value={option.idCategorie}>
                    {option.libCategorie}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item md={2} xs={12} sm={2}>
              <CategorieDialog />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={3} xs={12} sm={3}>
          <TextField
            fullWidth
            size="small"
            name="titre"
            label="Titre"
            value={blogState.titre}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={3} xs={12} sm={3}>
          <TextField
            fullWidth
            style={{ marginTop: 25 }}
            size="small"
            name="dateBlog"
            type="date"
            helperText="Date de l'évènement"
            value={blogState.dateBlog}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item md={3} xs={12} sm={3}>
          <TextField
            fullWidth
            size="small"
            name="signature"
            type="text"
            label="Signature"
            value={blogState.signature}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={4} xs={12} sm={4}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <img
                src={image ? image : "/img/image_template1.jpg"}
                style={{ width: "25vw", height: "30vh", border: "10px groove black"}}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image descriptive de l'actualité">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10, width: "100%" }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger l'image
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={8} xs={12} sm={8}>
          <TextField
            fullWidth
            multiline
            minRows={10}
            name="texteComplet"
            label="Saisir le texte complet"
            value={blogState.texteComplet}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <Divider />
        </Grid>
      </Grid>
    </Box>
  );
};







export const initialState = {
  titre: "",
  texteComplet: "",
  dateBlog: "",
  imageBlogEnBase64: "",
  idCategorie: null,
  signature: ""
}


const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [blogState, setBlogState] = useState<IPayloadBlog>(initialState)
  const [selectedPhoto, setSelectedPhoto] = useState<any>({})
  const [image, setImage] = useState<string>("");

  //Ouvrir la boite de dialog 
  const onClose = () => {
    setOpen(false)
  }

  //Fermer la boite de dialog
  const handleOpenDialog = () => {
    setOpen(true)
  }


  /**
   * Permet d'enregistrer une actualité dans la base de donnée
   * @param e 
   */
  const handleBlogSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)


      //Obtenir l'image qui decrit l'actualité en base 64
      const imageBlogEnBase64: any = selectedPhoto ? await convertToBase64(selectedPhoto) : "";

      //Constituer le payload final
      const apiPayload: IPayloadBlog = {
        ...blogState,
        imageBlogEnBase64: imageBlogEnBase64
      }

      // Envoi de la requête 
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/ajouterblog",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(addBlog(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setBlogState(initialState)
        // setImage("")
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      setAddLoading(false)
      console.log("🚀 ~ file: Add.tsx:305 ~ handleBlogSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          blogState={blogState}
          setBlogState={setBlogState}
          setSelectedPhoto={setSelectedPhoto}
          image={image}
          setImage={setImage}
        />}
      actionFunc={handleBlogSave}
      title="Blog"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



